import { AccountDetailsState, ActionType } from '../interfaces'

interface AccountDetailsAction {
  type: ActionType
}

const accountDetailsReducer = (
  initialState: AccountDetailsState,
  action: AccountDetailsAction,
): AccountDetailsState => {
  switch (action.type) {
    case ActionType.EXPAND_PAYMENT_INFO:
      return { ...initialState, accountOnHoldLinkClicked: true }
    case ActionType.RESET_CLICKED_STATE:
      return { ...initialState, accountOnHoldLinkClicked: false }
    default:
      throw new Error(`accountDetailsReducer: ${action.type} NOT IMPLEMENTED!`)
  }
}

export { AccountDetailsAction, accountDetailsReducer }
